// sanity_image.js
import imageUrlBuilder from '@sanity/image-url'
import client from './sanity_client'

const builder = imageUrlBuilder(client)

// Wraps @sanity/image-url so every callsite requests a resized, format-optimized
// asset instead of the full-resolution original (source of the CDN bandwidth spike).
export function urlFor(source) {
  return builder.image(source).auto('format')
}
